// Tiny session helper — stores the user's email locally so they don't
// need to re-enter it across reloads. CLAUDE.md §1: the storage key
// itself is env-driven.

import { env } from "./env";

export interface Session {
  email: string;
  signedInAt: string;
  isAdmin?: boolean;
}

const KEY = `${env.VITE_DEMO_SEED.split("-")[0] ?? "hgm"}.session.v1`;
const ADMIN_EMAIL = env.VITE_ADMIN_EMAIL;
const ADMIN_PASSWORD = env.VITE_ADMIN_PASSWORD;

export function getSession(): Session | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Session;
    if (typeof parsed.email !== "string" || !parsed.email.includes("@")) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setSession(s: Session): void {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* ignore */ }
}

export function clearSession(): void {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

export function isAdminCredential(email: string, password: string): boolean {
  return email.trim().toLowerCase() === ADMIN_EMAIL && password === ADMIN_PASSWORD;
}

export { ADMIN_EMAIL };
